export const monthFormat = Intl.DateTimeFormat(undefined, {
    month: "short",
    year: "numeric",
}).format;
